// helpers/helperPlugin.js
import * as stringUtils from './stringUtils';

export default {
  install(app) {
    app.config.globalProperties.$helpers = stringUtils;
  }
}
